/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReadOnlyMonitoredObjectGroupType,
    ReadOnlyMonitoredObjectGroupTypeFromJSON,
    ReadOnlyMonitoredObjectGroupTypeFromJSONTyped,
    ReadOnlyMonitoredObjectGroupTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface InlineResponse20022
 */
export interface InlineResponse20022 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20022
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20022
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20022
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<ReadOnlyMonitoredObjectGroupType>}
     * @memberof InlineResponse20022
     */
    results: Array<ReadOnlyMonitoredObjectGroupType>;
}

export function InlineResponse20022FromJSON(json: any): InlineResponse20022 {
    return InlineResponse20022FromJSONTyped(json, false);
}

export function InlineResponse20022FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineResponse20022 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(ReadOnlyMonitoredObjectGroupTypeFromJSON)),
    };
}

export function InlineResponse20022ToJSON(value?: InlineResponse20022 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'next': value.next,
        'previous': value.previous,
        'results': ((value.results as Array<any>).map(ReadOnlyMonitoredObjectGroupTypeToJSON)),
    };
}


